module.exports = __webpack_public_path__ + "static/img/strabismus_blance.5ec545f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strabismus_blance.png
// module id = Um9a
// module chunks = 3